import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DisdetailPageRoutingModule } from './disdetail-routing.module';

import { DisdetailPage } from './disdetail.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DisdetailPageRoutingModule
  ],
  declarations: [DisdetailPage]
})
export class DisdetailPageModule {}
